import axios from 'axios';
import store from 'store';
import jwt from 'jwt-decode';

// import { logout } from 'modules/auth/actions';
import { resetEnv } from 'modules/ui/actions';
import { refreshAuthToken } from 'modules/auth/actions'

let ENDPOINT = process.env.REACT_APP_API_URL;
let API_KEY = process.env.REACT_APP_API_KEY;

// var currentURI = window.location.href;
// var domain = /:\/\/([^\/]+)/.exec(currentURI)[1]; // eslint-disable-line

export const API_URL = ENDPOINT;

export const client = axios.create({
  baseURL: API_URL,
  responseType: 'json',
});

client.interceptors.request.use( async (config) => {
  const {
    auth: { token, refreshToken },
  } = store.getState();

  // Then, set the token for query endpoint
  if (token && refreshToken) {
    // Check if token is still valid, refresh it if needed
    const decodedToken = jwt(token);
    const decodedRefreshToken = jwt(refreshToken);

    if (decodedRefreshToken.exp  - Math.ceil(Date.now() / 1000) < 60) {
      // Disconnect
      store.dispatch(resetEnv());
      return Promise.reject();
    } else {
      if (decodedToken.exp - Math.ceil(Date.now() / 1000) < 120) {
        const response = await axios.post(`${API_URL}/frontend/auth/token`, {
          refreshToken
        })

        // Handle error in response (401)
        if (response.status !== 200) {
          

          store.dispatch(resetEnv());
          return Promise.reject();
        } else {


          store.dispatch(refreshAuthToken(response.data));
          config.headers.Authorization = `Bearer ${response.data.token}`;
        }
      } else {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
  }
  config.headers['Content-Type'] = 'application/json';
  config.headers['x-api-key'] = API_KEY;
  return config;
});

client.interceptors.response.use(null, error => {
  if (error.response && error.response.status === 401) {
    store.dispatch(resetEnv());
  }
  return Promise.reject(error);
});

// function hasInvalidToken(status, message) {
//   return status === 401;
// }

/**
 * post
 * @description common post request
 * @param {*} url
 * @param {*} data
 */
export function post(url, data) {
  return client({
    method: 'POST',
    url,
    data,
  });
}

/**
 * put
 * @description common post request
 * @param {*} url
 * @param {*} data
 */
export function put(url, data) {
  return client({
    method: 'PUT',
    url,
    data,
  });
}

/**
 * patch
 * @description common post request
 * @param {*} url
 * @param {*} data
 */
export function patch(url, data) {
  return client({
    method: 'PATCH',
    url,
    data,
  });
}

/**
 * get
 * @description common get request
 * @param {*} url
 * @param {*} params
 */
export function get(url, params) {
  return client({
    method: 'GET',
    url,
    params,
  });
}

/**
 * delete
 * @description common delete request
 * @param {*} url
 */
export function apiDelete(url) {
  return client({
    method: 'DELETE',
    url,
  });
}
